import { getPrice } from '@fourthwall/utils/dist'
import React from 'react'
import { Accordion } from '../../../../../../common/Accordion'
import { PriceString } from '../../../../../../functional/PriceString'
import { Input } from '../../../../../../inputs/Input'
import { InputUI } from '../../../../../../ui'
import { AccordionPanel } from '../AccordionPanel'
import * as S from './styled'
import type { CustomAccordionItemProps } from './types'

export const AccordionCustomItem = ({
  autoAdjustedSellingPrice,
  data,
  expanded,
  includeFeesValue,
  soldValue,
  soldValueError,
  onChange,
  onSoldValueChange,
  ...props
}: CustomAccordionItemProps) => {
  const isSoldValueValid = !!soldValue.length && !soldValueError

  return (
    <S.AccordionCustomItem paddingBottom={soldValueError ? 28 : 0}>
      <Accordion.Item
        disabled={!isSoldValueValid}
        expanded={isSoldValueValid && expanded}
        onChange={onChange}
        heading={
          <S.Heading>
            <S.CustomSoldContainer>
              <S.QuantityInputContainer>
                <Input
                  type="number"
                  size="small"
                  placeholder="Custom"
                  step={1}
                  min={0}
                  max={99999999}
                  hideSpinner
                  value={soldValue}
                  error={soldValueError}
                  displayError={false}
                  onChange={(event) => onSoldValueChange(event.target.value)}
                />
                <S.QuantityInputError>
                  {soldValueError && <InputUI.Error>{soldValueError}</InputUI.Error>}
                </S.QuantityInputError>
              </S.QuantityInputContainer>
              <span>sold</span>
            </S.CustomSoldContainer>
            {!expanded && isSoldValueValid && !!data.cost && (
              <div>
                <PriceString value={data.unitProfit} /> profit
              </div>
            )}
          </S.Heading>
        }
        footer={
          isSoldValueValid &&
          !!data.cost && (
            <S.TotalProfitContainer>
              <S.TotalProfitCopy top={expanded ? 0 : -8}>
                {`${getPrice(data.totalProfit)} for ${data.numberOfUnits} sold`}
              </S.TotalProfitCopy>
            </S.TotalProfitContainer>
          )
        }
        {...props}
      >
        <AccordionPanel
          price={data.price}
          cost={data.cost}
          profit={data.unitProfit}
          feesValue={data.feesValue}
          includeFeesValue={includeFeesValue}
          autoAdjustedSellingPrice={autoAdjustedSellingPrice}
        />
      </Accordion.Item>
    </S.AccordionCustomItem>
  )
}
